/** Angular */
import { Injectable } from '@angular/core';
/** Models */
import { DsPinPhotos } from '../models/ds-pin-photos';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DsPinPhotosService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get a list of pin photos.
   *
   * @param projectId the Project ID
   * @param pinId the pin ID
   * @returns Observable<DsPinPhotos>
   */
  public getPinPhotos(projectId: number, pinId: number) {
    this.path = `/v1/dspin/projects/${projectId}/pins/${pinId}/photos`;
    return this.getModel<DsPinPhotos>();
  }

  /**
   * Download blob of a bin comment.
   *
   * @param projectId Project ID.
   * @param pinId Pin ID.
   * @param commentId Comment ID.
   * @returns photo blob.
   */
  public getPinCommentPhoto(projectId: number, pinId: number, commentId: number): Observable<Blob> {
    this.path = `/v1/dspin/projects/${projectId}/pins/${pinId}/comments/${commentId}/photos`;
    return this.get<Blob>({ responseType: 'blob' });
  }

  /**
   * Create DsPinPhotos instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsPinPhotos` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): DsPinPhotos {
    return new DsPinPhotos(jsonObject);
  }
}
